import { createMedia } from '@tamagui/react-native-media-driver'

export const media = createMedia({
  desktop: { maxWidth: 1400 },
  tabletLandscape: { maxWidth: 1240 },
  tabletPortrait: { maxWidth: 905 },
  mobile: { maxWidth: 600 },

  // Greater than
  gtMobile: { minWidth: 600 + 1 },
  gtTabletPortrait: { minWidth: 905 + 1 },
  gtTabletLandscape: { minWidth: 1240 + 1 },
  gtDesktop: { minWidth: 1400 + 1 },
})

export const mediaQueryDefaultActive = {
  desktop: true,
  tabletLandscape: true,
  tabletPortrait: true,
  mobile: true,
}
